import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface LogoProps {}

export default function Logo(props: LogoProps) {
  return (
    <svg className='w-24 md:w-32 h-10' viewBox='0 0 131 41' xmlns='http://www.w3.org/2000/svg'>
      <path
        className='dark:fill-white'
        d='M52.5,1.4c-0.5-0.4-1-0.8-1.6-1C50.3,0.1,49.7,0,49,0c-0.7,0-1.3,0.1-1.9,0.4c-0.6,0.3-1.1,0.6-1.6,1
	c-0.4,0.4-0.8,0.9-1.1,1.5S44,4.1,44,4.8c0,0.6,0.1,1.3,0.4,1.9c0.3,0.6,0.6,1.1,1.1,1.5c0.4,0.4,1,0.8,1.6,1
	c0.6,0.3,1.3,0.4,1.9,0.4c0.7,0,1.3-0.1,1.9-0.4c0.6-0.3,1.1-0.6,1.6-1c0.5-0.4,0.8-0.9,1.1-1.5C53.9,6,54,5.4,54,4.8
	s-0.1-1.3-0.4-1.8C53.4,2.3,53,1.8,52.5,1.4z'
      />
      <path
        className='dark:fill-white'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M77.6,12.4c0.6,0.4,1.1,0.9,1.5,1.4V1.6h7.5v38.9H71.7c-2.1,0-4-0.4-5.8-1.1c-1.8-0.7-3.4-1.8-4.7-3.1
	c-1.4-1.3-2.4-2.9-3.2-4.7c-0.8-1.8-1.2-3.8-1.2-5.9s0.4-4.1,1.2-5.9c0.8-1.8,1.8-3.4,3.2-4.7c1.4-1.3,2.9-2.4,4.7-3.1
	c1.8-0.8,3.7-1.1,5.8-1.1c0.7,0,1.3,0.1,2,0.2s1.4,0.3,2,0.5C76.4,11.7,77.1,12,77.6,12.4z M78.1,30.2l2.1,4.1l-4.4-2.1
	c-0.8,0.4-1.6,0.7-2.5,0.9c-0.5,0.1-1.1,0.2-1.6,0.2c-0.7,0-1.3-0.1-2-0.3c-3.4-0.8-6-3.8-6-7.4c0-4.2,3.6-7.6,7.9-7.6
	c4.4,0,7.9,3.4,7.9,7.6C79.6,27.3,79.1,28.9,78.1,30.2z'
      />
      <path className='dark:fill-white' d='M92.3,1.6h7.5v38.9h-7.5V1.6z' />
      <path
        className='dark:fill-white'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M122.8,32.2c0.6-0.4,1.1-0.8,1.6-1.3l0,0c0.5-0.5,0.8-1.1,1.1-1.7l5.4,5.3c-0.7,0.9-1.5,1.8-2.4,2.5
	c-0.9,0.7-1.9,1.4-2.9,1.9c-1,0.5-2.1,0.9-3.3,1.2c-1.2,0.3-2.3,0.4-3.6,0.4c-2.1,0-4-0.4-5.8-1.1c-1.8-0.7-3.4-1.8-4.7-3.1
	c-1.4-1.3-2.4-2.9-3.2-4.7c-0.8-1.8-1.2-3.7-1.2-6c0-2.2,0.4-4.2,1.2-6.1c0.8-1.8,1.8-3.4,3.2-4.7c1.4-1.3,2.9-2.3,4.7-3
	c1.8-0.7,3.7-1.1,5.8-1.1c1.2,0,2.4,0.1,3.6,0.4c1.2,0.3,2.3,0.7,3.3,1.2c1,0.5,2,1.2,2.9,1.9c0.9,0.8,1.7,1.6,2.4,2.6l-14,16.2
	c0.3,0.1,0.6,0.1,0.9,0.2c0.3,0,0.6,0,0.9,0c0.7,0,1.4-0.1,2.1-0.3C121.6,32.8,122.2,32.5,122.8,32.2z M111.8,28.5
	c0.1,0.3,0.2,0.6,0.4,0.8l0,0l8.7-11.1c-0.3-0.1-0.7-0.2-1-0.2c-0.3,0-0.7-0.1-1-0.1c-1,0-2,0.2-2.9,0.5c-0.9,0.4-1.7,0.9-2.3,1.5
	c-0.7,0.7-1.2,1.5-1.6,2.4c-0.4,0.9-0.6,2-0.6,3.2c0,0.3,0,0.6,0,0.9c0,0.3,0.1,0.7,0.1,1C111.7,27.9,111.8,28.2,111.8,28.5z'
      />
      <path className='dark:fill-white' d='M45.2,12.4h7.5v28.1h-7.5V12.4z' />
      <path
        className='dark:fill-white'
        d='M39,13.4L39,13.4l0-8.7c0-1.7-1.4-3.2-3.2-3.2H3.2C1.4,1.6,0,3,0,4.7v8.7l0,0c0,0.1,0,0.2,0,0.2v26.8h7.8V13.6
	c0-0.5,0.1-1,0.3-1.5c0.2-0.5,0.5-0.9,0.8-1.2c0.4-0.3,0.8-0.6,1.2-0.8c0.5-0.2,1-0.3,1.5-0.3c0.5,0,1.1,0.1,1.5,0.3
	c0.5,0.2,0.9,0.5,1.2,0.8c0.4,0.3,0.6,0.7,0.8,1.2c0.2,0.5,0.3,0.9,0.3,1.5v26.8h7.8V13.6c0-0.5,0.1-1,0.3-1.5
	c0.2-0.5,0.5-0.9,0.8-1.2c0.4-0.3,0.8-0.6,1.2-0.8c0.5-0.2,1-0.3,1.5-0.3s1.1,0.1,1.5,0.3c0.5,0.2,0.9,0.5,1.2,0.8
	c0.4,0.3,0.6,0.7,0.8,1.2c0.2,0.5,0.3,0.9,0.3,1.5v26.8H39V13.6C39,13.6,39,13.5,39,13.4z'
      />
    </svg>
  );
}
